
const NotFound = () => {
    return (
        <div className="mt-[100px] flex flex-col items-center justify-center">
            <h1 className="text-9xl font-bold text-gray-800">404</h1>
            <h2 className="text-3xl font-semibold text-gray-700 mt-4">Page Not Found</h2>
            <p className="text-gray-500 mt-2 mb-6">
                The page you are looking for does not exist.
            </p>
        </div>
    );
};

export default NotFound;